import { render, staticRenderFns } from "./Pendencia.vue?vue&type=template&id=60dfa72e"
import script from "./Pendencia.vue?vue&type=script&lang=js"
export * from "./Pendencia.vue?vue&type=script&lang=js"
import style0 from "./Pendencia.vue?vue&type=style&index=0&id=60dfa72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports